export * from './lib/control.component';
